// extracted by mini-css-extract-plugin
export default {"search_details":"FilterDetails_search_details__EvrYu"};